// NotificationEditPage.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export const NotificationIndividualEdit = () => {
  const { notificationId } = useParams();
  const navigator = useNavigate();
  const [notification, setNotification] = useState({
    _id: "",
    parent_id: "",
    user_id: "",
    blog_id: "",
    type: "",
    status: "",
    createdAt: "",
  });
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        // console.log(data.message);
        if (data.message == "Please login first") {
          console.log("aad");
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  useEffect(() => {
    const getNotification = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/blogs/notification/indi/${notificationId}`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        setNotification(data);
      } catch (error) {
        console.log(error);
      }
    };

    getNotification();
  }, [notificationId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNotification((prevNotification) => ({
      ...prevNotification,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/notification/edit/${notificationId}`,
        notification,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      // Redirect to the individual notification page after editing
      navigator(`/notifications/${notificationId}`);
    } catch (error) {
      console.log(error);
    }
  };

  if (!notification) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Typography variant="h4">Edit Notification</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Parent ID"
          name="parent_id"
          value={notification.parent_id}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="User ID"
          name="user_id"
          value={notification.user_id}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Blog ID"
          name="blog_id"
          value={notification.blog_id}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Type"
          name="type"
          value={notification.type}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Status"
          name="status"
          value={notification.status}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Created At"
          name="createdAt"
          value={notification.createdAt}
          onChange={handleChange}
        />
        {/* Add more form fields based on your notification schema */}
        <Button type="submit" variant="contained" color="primary">
          Save Changes
        </Button>
      </form>
    </div>
  );
};
